<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="2" id="dramatis-personae">
<h1 data-number="2">Dramatis Personae</h1>
<div class="hanging_indent_frontmatter">
<p>ICOLA, GNAEUS JULIUS<sup>*</sup> <em>Caecina Severus’s oldest friend</em></p>
<p>AULUS <em>Caecina Severus’s son</em></p>
<p>ALPINUS, JULIUS<sup>*</sup> <em>Alpine rebel</em></p>
<p>BASSUS, LUCILIUS<sup>*</sup> <em>Admiral of the fleet</em></p>
<p>CERBERUS <em>Prefect of the Silian cavalry</em></p>
<p>DOMITIA<sup>*</sup> <em>Julius Agricola’s wife</em></p>
<p>GALBA, SERVIUS SULPICIUS<sup>*</sup> <em>Emperor of Rome</em></p>
<p>GALERIA<sup>*</sup> <em>Vitellius’s wife</em></p>
<p>GERMANICUS, AULUS VITELLIUS<sup>*</sup> <em>Governor of Lower Germania and Emperor of Rome</em></p>
<p>LACO, CORNELIUS<sup>*</sup> <em>Galba’s praetorian prefect</em></p>
<p>LUGUBRIX <em>Grain merchant from Gaul</em></p>
<p>MARTIANUS, ICELUS<sup>*</sup><em>Galba’s freedman</em></p>
<p>OTHO, MARCUS SALVIUS<sup>*</sup> <em>Emperor of Rome</em></p>
<p>PANSA <em>Legate of the XXI Rapax</em></p>
<p>PAULINUS, SUETONIUS<sup>*</sup> <em>Roman general, defeated Boudicca’s rebellion</em></p>
<p>PRIMUS, ANTONIUS<sup>*</sup> <em>Legate of VII Galbiana in Pannonia</em></p>
<p>RUFUS, VERGINIUS<sup>*</sup> <em>Previous governor of Lower Germania</em></p>
<p>SABINUS, FLAVIUS<sup>*</sup> <em>Brother of Vespasian</em></p>
<p>SABINUS, PUBLILIUS<sup>*</sup> <em>Prefect of an auxiliary cohort</em></p>
<p>SALONINA<sup>*</sup> <em>Caecina Severus’s wife</em></p>
<p>SEVERUS, AULUS CAECINA (later AULUS CAECINA ALIENUS)<sup>*</sup> <em>Legate of the IV Macedonica and Vitellian general</em></p>
<p>TOTAVALAS <em>Caecina Severus’s Hibernian freedman</em></p>
<p>TUSCUS, GAIUS <em>Camp Prefect of IV Macedonica</em></p>
<p>VALENS, FABIUS<sup>*</sup> <em>Legate of the I Germanica and Vitellian general</em></p>
<p>VESPASIAN<sup>*</sup> <em>General charged with putting down the Jewish Revolt</em></p>
<p>VINDEX, JULIUS<sup>*</sup> <em>Leader of the Vindex rebellion</em></p>
<p>VINDEX, QUINTUS <em>Julius Vindex’s son and Tribune of the IV Macedonica</em></p>
<p>VINIUS, TITUS<sup>*</sup> <em>Confidant of Galba</em></p>
<p>VOCULA, DILLIUS<sup>*</sup> <em>Legate of the XXII Primigenia</em></p>
</div>
<p><sup>*</sup><em>Historical character</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?585572cb